'use client';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { PortalSimple } from '@components/portal-simple/PortalSimple';
import infoIcon from '@images/svg/info.svg';
import Svg from 'react-inlinesvg';
import styles from './TooltipComponent.module.scss';

export const TooltipComponent = ({ text, id = 'duty', place = 'bottom-end', children }) => {
  const hasHtml = Boolean(children);

  return (
    <span className={styles.tooltipBlock}>
      <Svg
        src={infoIcon?.src}
        data-tooltip-id={id}
        {...(!hasHtml ? { 'data-tooltip-content': text } : {})}
        className={styles.icon}
      />

      <PortalSimple>
        <Tooltip
          id={id}
          place={place}
          offset={10}
          positionStrategy='fixed'
          clickable={hasHtml}
          className={styles.tooltip}
          classNameArrow={styles.tooltipArrow}
        >
          {children}
        </Tooltip>
      </PortalSimple>
    </span>
  );
};
